export const TILE_TRACK_LINK = (edit) =>
  edit
    ? 'account-profile:account management:information edit'
    : 'account-profile:account management:first time edit';

export const ANALYTICS = {
  TRACKING_CONTAINER: 'utilitynav',
  TRACK_ICON_HELP: 'account-profile:account management:help',
  TRACK_MENU_TUTORIALS:
    'account-profile:account management:tutorials and troubleshooting',
  TRACK_MENU_CONTACT: 'account-profile:account management:contact support',
  TRACK_ICON_AVATAR: 'account-profile:account management:trials',
  EVENT_PAGE_VIEW: 'page_view',
  EVENT_LINK_CLICK: 'link_click',
  TRACK_LINK_EVENT: {
    personalinfo: 'account-profile:account management:personal information',
    security: 'account-profile:account management:security',
    settings: 'account-profile:account management:settings',
    home: 'account-profile:account management:my profile and settings',
  },
  TRACK_ARTIFICIAL_PAGEVIEW: {
    personalinfo: 'adsk:account-profile:personalinfo',
    security: 'adsk:account-profile:security',
    settings: 'adsk:account-profile:settings',
    home: 'adsk:account-profile:home',
  },
};
